import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { promobannerStore } from '../../store/promobannerStore';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { allowedImageTypes } from 'src/view/components/Controls/Upload/constants';
import Upload from 'src/view/components/Controls/Upload/Upload';
import './style.scss';

@observer
export default class PromobannerUpload extends React.Component<{}, {}> {
  changeImage = (image: string) => {
    promobannerStore.changePromobanner({ image }, true);
  };

  render() {
    return (
      <>
        <p className="family-regular text-size-12 color-gray2 text-weight-500 mt-4">{localeStore.t('promobanner_img_requirements')}</p>
        <Upload
          image={promobannerStore.promobanner.image}
          changeFile={this.changeImage}
          params={{ is_additional: 0 }}
          initialAspectRatio={27 / 10}
          aspectRatio={27 / 10}
          allowedFileTypes={allowedImageTypes}
          maxFileSize={2097152} // 2 mb
          type="promo_banner"
          className={classNames('upload-wrapper mt-2', { 'input-error': !promobannerStore.isValid.image })}
        >
          <div className="promobanner-upload d-flex flex-column align-items-center justify-content-center full-width">
            <div className="promobanner-upload__container">
              <span className="promobanner-upload__square promobanner-upload__square_blue"></span>
              <span className="promobanner-upload__square promobanner-upload__square_gray"></span>
              <Icon name={Icons.Hand} size={45} className="promobanner-upload__icon color-gray2" />
            </div>
            <p className="family-regular text-size-18 color-dark mt-6 required">{localeStore.t('drag_and_drop_or_click_here_to_select_file')}</p>
          </div>
        </Upload>
      </>
    );
  }
}
